import {
  CURRENT_LOCATION_FAIL,
  CURRENT_LOCATION_SUCCESS,
} from "../Constants/CurrentLocationConstants";

// CURRENT LOCATION
export const currentLocationReducer = (state = {}, action) => {
  switch (action.type) {
    case CURRENT_LOCATION_SUCCESS:
      return {
        loading: false,
        location: action.payload,
      };
    case CURRENT_LOCATION_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
